const REGISTERED_FILTER_CONFIG_KEYS = new Set<string>();

export function registerFilterConfigKey(key: string) {
  if (REGISTERED_FILTER_CONFIG_KEYS.has(key)) {
    throw new Error(`Filter config key "${key}" is already registered.`);
  }

  REGISTERED_FILTER_CONFIG_KEYS.add(key);
}
